import { getUserVisibleOrDefaultExceptionMessage } from '@paragon/client-tools';
import { sealingService } from '@paragon/data-connections';
import { getChildrenFinder, getComponentDesignDescendantGuids } from '@paragon/layout-models';
import { enqueueWarning } from '@paragon/notification-tools';

import { componentDesignSealTimestampsLoaded } from '../slices/componentDesignSealTimestamps';
import { sealLoadingFinishedForProject, sealLoadingStartedForProject } from '../slices/gridSlice';
import { loadHistoriesForComponentDesigns } from './analysisHistory';
import { loadComponentDesignSummaries } from './projects';
import { AsyncThunkActionVoid } from './thunkActions';

export const getComponentDesignSealTimestampsForProject =
  (projectGuid: string): AsyncThunkActionVoid =>
  async (dispatch) => {
    const data = await sealingService.jobs.getComponentDesignSealTimestamps(projectGuid);
    dispatch(componentDesignSealTimestampsLoaded(data));
  };

export const getAllInformationForSealedStatus =
  (projectGuid: string): AsyncThunkActionVoid =>
  async (dispatch, getState) => {
    const componentDesignGuids = getComponentDesignDescendantGuids(projectGuid, getChildrenFinder(getState()));

    dispatch(sealLoadingStartedForProject({ projectGuid }));
    try {
      await Promise.all([
        dispatch(loadHistoriesForComponentDesigns(componentDesignGuids)),
        dispatch(getComponentDesignSealTimestampsForProject(projectGuid)),
        dispatch(loadComponentDesignSummaries(componentDesignGuids)),
      ]);
    } catch (error) {
      console.error(error);
      dispatch(
        enqueueWarning(
          getUserVisibleOrDefaultExceptionMessage(
            error,
            'Error loading seal data. Some components may incorrectly show as unsealed.',
          ),
        ),
      );
    } finally {
      dispatch(sealLoadingFinishedForProject({ projectGuid }));
    }
  };
